import React, {memo, useMemo} from 'react';
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useFormik} from "formik";

import {
  useGetGoogleInfoQuery,
  useGetTenancyByIdQuery,
  useSetGoogleInfoMutation
} from "../../../redux/api/TenancyApi";
import {Load} from "../../../components/load/Load";
import {TabBlocksAdServices, TabBlocksGoogle, TabsBlock} from "../TenancySettings";
import FormikSelect from "components/formComponents/FormikSelect";

export const creditLineTypes={
  Adverton:"Adverton",
  Personal:"Personal"
}


const InnerInfo = memo(({id}) => {
  const {t} = useTranslation("tenancy");
  const {data, isLoading} = useGetGoogleInfoQuery(id);
  const [setData, {isLoading: setIsLoading}] = useSetGoogleInfoMutation();
  const onSubmit = (values) => {
    console.log("values", values)
    setData({
      ...values,
      id
    }).then(({error}) => {
      !error && swal({
        icon: "success",
        text: "Data saved successfully"
      })
    })
  }
  const options = useMemo(() => ([
    {label: t(creditLineTypes.Adverton), value: creditLineTypes.Adverton},
    {label: t(creditLineTypes.Personal), value: creditLineTypes.Personal},
  ]), [t]);

  const formik = useFormik({
    initialValues: {
      creditLineType: data?.creditLineType ? {label: t(data.creditLineType), value: data.creditLineType} : {
        label: t("pleaseSelect"),
        value: undefined
      },
    },
    onSubmit
  });

  if (isLoading) {
    return <Load/>
  }

  return (<form className={"border-bottom bg-white p-4"} onSubmit={formik.handleSubmit}>
    <div className="col-4 px-0 mt-3">
      <label htmlFor="legalCountry" className="input-element-label">{t("creditLineType")}</label>
      <FormikSelect
        name="creditLineType"
        options={options}
        formik={formik}
        className="pb-3 pl-0 position-relative"
      />
    </div>
    {formik.values.creditLineType?.value === creditLineTypes.Adverton && <p>{t("advertonGoogleDesc")}</p>}
    <div className={"d-flex justify-content-center col-4 px-0 pt-4"}>
      <button className={"btn btn-primary px-4"}
              disabled={setIsLoading}
              type={"submit"}>{t("save", {ns: "translation"})}</button>
    </div>
  </form>)
})

const AdSystemTenancyGoogleCreditLine = () => {
  const {id} = useParams();
  const {data, isLoading} = useGetTenancyByIdQuery(id);
  const {data: googleData, isLoading: googleIsLoading} = useGetGoogleInfoQuery(id);

  if (isLoading || googleIsLoading) {
    return <Load/>
  }

  return (
    <div>
      <h1 className={"pb-4"}>{data?.legalCompanyNameEn}</h1>
      <TabsBlock id={id}/>
      <TabBlocksAdServices id={id}/>
      <TabBlocksGoogle id={id} isBlockLast={googleData?.creditLineType !== creditLineTypes.Personal}/>
      <InnerInfo id={id}/>
    </div>
  );

};

export default AdSystemTenancyGoogleCreditLine;